import React, { Component } from "react";
import InputMask from 'react-input-mask';

class ShortText extends Component {
    constructor(props){
        super(props);
        this.state = {
            error:"",
            errors:""
        }
    }

    onChangeHandler = async (event) => {
        const {name, value} = event.currentTarget
        this.props.onChange(value)
    }

    render() {
        return (
            <>
                {this.props.type === 'number' &&
                    <InputMask mask="9999" className="inputText" maskChar="" onChange={this.onChangeHandler}/>
                }
                {this.props.type !== 'number' &&
                    <input
                    className="inputText"
                    type="text"
                    onChange={this.onChangeHandler}
                    placeholder="Type your answer here..."/>
                }
            </>
        );
    }
}

export default ShortText;
